import Vue from "vue";
import axios from "axios";
import { router } from "../router/index";
import MainTermsAndPolicy from "@/components/cowork/general/main/modal/MainTermsAndPolicy";

import i18nUtil from "@/locales/I18nUtil"

axios.interceptors.request.use(
  async function(config) {
    config.headers.refreshToken = localStorage.getItem("refreshToken");
    config.headers.Authorization = localStorage.getItem("Authorization");
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    if (response.status == 200) {
      if (response.data.result != null || response.data.result != undefined) {
        if (response.data.result.accessToken) {
          localStorage.setItem(
            "Authorization",
            `Bearer ${response.data.result.accessToken}`
          );
        }
        if (response.data.result.refreshToken) {
          localStorage.setItem(
            "refreshToken",
            response.data.result.refreshToken
          );
        }
      } else {
        if (response.data.errorCode != null) {
          let errorCode = response.data.errorCode;

          if (errorCode == "AUTH_REFRESH_TOKEN_INVALID") {
            /* refreshToken 변조 혹은 이상일 경우 login 페이지로 이동 */
            console.log("AUTH_REFRESH_TOKEN_INVALID");
            localStorage.removeItem("Authorization");
            localStorage.removeItem("refreshToken");
            if(document.location.href.indexOf("hanwhalife") > -1){
              router.replace("/hcpsso/sso_login");
            }else{
              router.replace("/login");
            }
          } else if (errorCode == "AUTH_REFRESH_TOKEN_EXPIRED") {
            console.log("AUTH_REFRESH_TOKEN_EXPIRED");
            alert(
              i18nUtil.trans("AG034", "장시간 사용하지 않아 로그아웃 되었습니다.\n재 로그인 후 사용해주세요.")
            );
            localStorage.removeItem("Authorization");
            localStorage.removeItem("refreshToken");
            if(document.location.href.indexOf("hanwhalife") > -1){
              router.replace("/hcpsso/sso_reLogin");
            }else{
              router.replace("/reLogin");
            }
          } else if (errorCode == "AUTH_NO_REFRESH_TOKEN_INFO") {
            console.log("AUTH_NO_REFRESH_TOKEN_INFO");
            localStorage.removeItem("Authorization");
            localStorage.removeItem("refreshToken");
            if(document.location.href.indexOf("hanwhalife") > -1){
              router.replace("/hcpsso/sso_login");
            }else{
              router.replace("/login");
            }
          } else if (errorCode == "AUTH_LOGIN_FAIL") {
            /* 아이디 혹은 비밀번호로 인한 로그인 실패 */
            alert(
              i18nUtil.trans("AG006", "아이디 또는 비밀번호를 잘못 입력하셨습니다.\n동일 아이디 5회 이상 실패 시 계정 잠금 상태로 전환됩니다.")
            );
          } else if (errorCode == "AUTH_LOGIN_PASSWORD_FAIL_LOCK") {
            alert(
              i18nUtil.trans("message.interceptor.003", "5회 입력 실패하여 계정 잠금 상태로 전환 되었습니다.\n사용자 인증 후 비밀번호를 재설정 해주시기 바랍니다.")
            );
          } else if (errorCode == "ALREADY_LOGIN_USER") {
            alert(
              i18nUtil.trans("message.interceptor.002", "이미 로그인 된 사용자 입니다.")
            );
          } else if (errorCode == "NOT_AUTHORIZED") {
            let toastInfo = {
              message: i18nUtil.trans("message.interceptor.001", "접근 권한이 없습니다."),
              options: {
                theme: "toasted-primary",
                position: "bottom-left",
                duration: 3000
              }
            };
            /* 권한없음 토스트 중복 처리 */
            {
              let duplicated = false;
              for (let toast of Vue.toasted.toasts) {
                // console.log("TOASTED:", toast.el.innerText);
                if (toast.el.innerText == toastInfo.message) {
                  duplicated = true;
                  break;
                }
              }
              if (!duplicated) {
                // console.log("SHOW TOAST:", toastInfo.message);
                Vue.toasted.show(toastInfo.message, toastInfo.options);
              }
            }
            //router.next();
          } else {
          }
        } else {
        }
      }
    }
    return response;
  },
  function(error) {
    if (error.response.status != 200) {
      if (error.response.status === 401) {
        const config = error.config;
        return axios
          .post("/api/auth/renewalAccessToken")
          .then(function(res) {
            return new Promise((resolve, reject) => {
              axios
                .request(config)
                .then(response => {
                  resolve(response);
                })
                .catch(error => {
                  reject(error);
                });
            });
          })
          .catch(function(err) {
            console.log(err);
          });
      } else if (error.response.status === 403) {
        localStorage.removeItem("Authorization");
        localStorage.removeItem("refreshToken");
        if(document.location.href.indexOf("hanwhalife") > -1){
          router.replace("/hcpsso/sso_reLogin");
        }else{
          router.replace("/reLogin");
        }
      } else {
      }
    }
    return Promise.reject(error);
  }
);
export default "./interceptor";



// WEBPACK FOOTER //
// ./src/router/interceptor.js